import { Check } from "@mui/icons-material";
import useCategory from "../utils/useCategory";
import { getLang, txt } from "../../../services/translation";

export default function Free(){

    const category = useCategory();

    return (

        <div className="apply-option" style={{ borderColor: category.color }}>

            <div className="apply-option-top" style={{backgroundColor: category.color, color: 'white'}}>
                <Check sx={{fontSize: 22}} />
                <span>{txt('selected')}</span>
            </div>
                
            <div className="apply-option-title">
                <span>{txt('offer')}</span>
            </div>

             <div className="apply-option-row">
                <span>{txt('free100')}</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>{txt('withoutCommitment')}</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>{txt('immediateAccess')}</span>
            </div>

            {getLang() === 'fr' && <>
                <div className="apply-option-divider"></div>

                <div className="apply-option-row">
                    <span>{txt('hoursOfTraining', { n: 2 })}</span>
                </div>
            </>}

        </div>
    );
}